module.exports = __webpack_public_path__ + "img/k12_feature2.2e8156bf.png";